import { ReactNode, TextareaHTMLAttributes } from 'react'
import { INPUT_FOCUS_RING } from '../../../lib/a11yFocus'
import { FORM_INPUT_TEXT_CLASS, FORM_LABEL_CLASS } from '../../../lib/formStyles'

type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
	label?: ReactNode
	error?: string
}

/** Canonical free-text field: same green focus ring as Input, for mouse and keyboard focus. */
function TextArea({ label, error, className = '', id, name, ...props }: TextAreaProps) {
	const fieldId = id ?? name
	const field = (
		<textarea
			{...props}
			id={fieldId}
			name={name}
			aria-invalid={error ? true : undefined}
			className={`block w-full rounded shadow-sm ${FORM_INPUT_TEXT_CLASS} ${INPUT_FOCUS_RING} ${
				error ? 'border-error-500 bg-error-050 text-error-800 focus:border-error-500 focus:ring-error-500' : 'text-charcoal-800'
			} ${className}`}
		/>
	)

	if (!label && !error) return field

	return (
		<div>
			{label && (
				<label htmlFor={fieldId} className={`block ${FORM_LABEL_CLASS} my-1`}>
					{label}
				</label>
			)}
			{field}
			{error && <p className='mt-2 text-sm text-error-700'>{error}</p>}
		</div>
	)
}

export default TextArea
